export function calcGridPos(cellSize) {
    var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
    var gridSize = cellSize * 9;
    var x = Math.ceil((innerWidth - gridSize) / 2);
    var y = Math.floor(innerHeight / 2 - gridSize / 2 - cellSize / 2 + 10);
    return { x: x, y: y };
}
